import upsertThreadEvent from '@/redux/actions/pieveActions/upsertThreadEvent.js';

export const toLines = (text) => {
  const normalized = String(text || '');

  if (!normalized) {
    return [{ text: '' }];
  }

  return normalized.split('\n').map((line) => {
    return {
      text: line
    };
  });
};

export const extractOptimisticInputAttachments = ({ inputItems = [] } = {}) => {
  const safeInputItems = Array.isArray(inputItems) ? inputItems : [];
  const attachments = [];

  for (const inputItem of safeInputItems) {
    if (!inputItem || typeof inputItem !== 'object' || Array.isArray(inputItem)) {
      continue;
    }

    const inputType = String(inputItem?.type || '')
      .trim()
      .toLowerCase();

    if (inputType !== 'file') {
      continue;
    }

    const attachment = inputItem?.attachment && typeof inputItem.attachment === 'object' && !Array.isArray(inputItem.attachment) ? inputItem.attachment : {};
    const attachmentId = String(inputItem?.attachmentId || inputItem?.attachment_id || attachment?.attachmentId || attachment?.attachment_id || '').trim() || null;
    const mediaKindRaw = String(inputItem?.mediaKind || inputItem?.media_kind || attachment?.mediaKind || attachment?.media_kind || '')
      .trim()
      .toLowerCase();
    const mediaKind = mediaKindRaw === 'image' ? 'image' : 'document';
    const mimeType = String(inputItem?.mimeType || inputItem?.mime_type || attachment?.mimeType || attachment?.mime_type || '').trim() || null;
    const filename = String(inputItem?.filename || attachment?.filename || '').trim() || attachmentId || null;
    const sizeCandidate = Number(inputItem?.sizeBytes ?? inputItem?.size_bytes ?? attachment?.sizeBytes ?? attachment?.size_bytes);
    const sizeBytes = Number.isFinite(sizeCandidate) && sizeCandidate > 0 ? Math.floor(sizeCandidate) : null;
    const path = String(attachment?.path || '').trim() || null;
    const downloadUrl = String(inputItem?.downloadUrl || inputItem?.download_url || attachment?.downloadUrl || attachment?.download_url || '').trim() || null;

    attachments.push({
      attachmentId,
      mediaKind,
      mimeType,
      filename,
      sizeBytes,
      path,
      downloadUrl
    });
  }

  return attachments.filter((attachment) => {
    return attachment.attachmentId || attachment.filename || attachment.path;
  });
};

export const buildOptimisticUserEvent = ({ eventId, runId, text, createdAt, inputItems = [] } = {}) => {
  const attachments = extractOptimisticInputAttachments({ inputItems });

  return {
    id: eventId,
    type: 'bubble',
    className: 'user',
    lines: toLines(text),
    runId,
    createdAt,
    ...(attachments.length > 0
      ? {
          attachments
        }
      : {})
  };
};

const appendOptimisticUserBubble = ({ dispatch, getState, threadId, eventId, runId, text, createdAt, inputItems = [] } = {}) => {
  const submissionToken = getState?.()?.ui?.threadSurfaceSubmitRequest?.submissionToken || null;
  const optimisticEvent = buildOptimisticUserEvent({
    eventId,
    runId,
    text,
    createdAt,
    inputItems
  });

  dispatch(
    upsertThreadEvent({
      threadId,
      event: submissionToken ? { ...optimisticEvent, submissionToken } : optimisticEvent
    })
  );
};

export default appendOptimisticUserBubble;
